export default "__VITE_ASSET__0bd38bf1__"